import App from 'app/app.js';
import 'app/service/BlockService.js';

function LtDrawerDirective(BlockService, $rootScope) {
  // Collection of drawer elements and their display state
  var dictionary = [];

  return {
    link: function (scope, element, attrs) {
      var unwatch;

      // The element needs to be added to the dictionary because its assume to be added
      // in the watcher defined below
      dictionary.push({
        key: element,
        value: null
      });

      // The element must be removed on destroy to prevent it from continuing to affect
      // calculations after it no longer exists
      element.on('$destroy', function () {
        var index = R.findIndex(R.propEq('key', element))(dictionary);
        dictionary.splice(index, 1);
        unwatch();
      });

      unwatch = scope.$watch(attrs.ltDrawer, function (value) {
        var some, cancelCallback;

        // The drawer visibility needs to be set regardless of what happens with the blocking
        element.toggle(value);

        // It's assumed that the element entry is in the dictionary, find it and update it
        R.find(R.propEq('key', element))(dictionary).value = value;

        // Need to determine if any of the drawers are visible because then the blur needs to remain
        some = R.any(function (e) {
          return !!e.value;
        })(dictionary);

        // Cancel callback needs to be registered only when showing the drawer
        if (!!attrs.ltDrawerCancellation && value) {
          cancelCallback = function () {
            scope.$evalAsync(attrs.ltDrawerCancellation);
          };
        }

        $rootScope.isModalOpen = some;

        BlockService.toggleBlockBelowDrawer(some, cancelCallback);
      });
    }
  };
}

App.directive('ltDrawer', ['BlockService', '$rootScope', LtDrawerDirective]);
